import './styles/AppLoader.css';

import { useLocale } from 'containers/App/LocaleContext';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import type { FC } from 'react';

export const AppLoader: FC = () => {
  const appLoaderMsg = useLocale().appLoader;

  return (
    <div className='app-loader__background'>
      <div className='app-loader__content'>
        <LoaderAndText
          text={appLoaderMsg.loaderText}
          bottomText={appLoaderMsg.bottomText}
        />
      </div>
    </div>
  );
};
